import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { AttributeTypeService } from '../services/attribute-type.service';
import { BaseEntity } from '../base/BaseEntity';
import { MatSelectChange } from '@angular/material/select';


@Component({
  // tslint:disable-next-line: component-selector
  selector: 'attribute-type-combo',
  templateUrl: './attribute-type-combo.component.html',
  styleUrls: ['./attribute-type-combo.component.css']
})
export class AttributeTypeComboComponent implements OnInit {

  data: IBaseEnum[];
  selected: any;
  constructor(
    public attributeTypes: AttributeTypeService
  ) {

  }

  @Input() value;
  @Input() disabled: boolean;
  @Output() selectedChange = new EventEmitter<IBaseEnum>();

  ngOnInit() {
    this.attributeTypes.GetCached().subscribe((result) => {
      this.data = <IBaseEnum[]>result;
    });
  }
  OnSelected(e: MatSelectChange) {
    if (this.data) {
      const ret = this.data.find(elem => elem.id === e.value);
      this.selectedChange.emit(ret);
    }
  }
}

export interface IBaseEnum {
  id: string;
  name: string;
}
